export function policyInsurerPrimary(data) {
  return {
    policyID: data.PolicyID,
    policyName: data.PolicyName,
  };
}

export function insurerMergeFieldsBuilderForUI(data) {
  return data.Policies.map(policyInsurerPrimary);
}

export function emailRecipient(recipient) {
  // Note: This corresponds to the contacts/EmailSend API recipients
  return {
    EmailAddress: recipient.emailAddress,
    Name: recipient.name,
    FamilyId: recipient.familyId,
  };
}
